export enum RedirectPage {
  Intro,
  MfaDisabled,
  NegativeBalance,
  FundingSourceListPendingExternalInternalVerification,
  VerifyCustomer,
  FundingSourceListPendingInternalVerification,
  ExpressPayIntro,
  ActivityList,
  None
}

export enum DoAction {
  None,
  Details,
  Request,
  Pay
}

export enum PaymentsCreateFundingSourceErrorCode {
  ServerError,
  ValidationError,
  AllDuplicateAccount,
  SomeDuplicateAccount,
  NotApproved,
  FundingSourceLimitReached
}

export enum CreateTransferErrorCode {
  ServerError,
  ValidationError,
  MfaDisabled,
  InvalidFee,
  NotApproved,
  NotEligibleToMakePayments,
  LinkUpdateRequired,
  NotEligibleForNextDayAch,
  InsufficientBalance,
  ExceedsDailyLimit
}

export enum CreateScheduledPaymentErrorCode {
  ServerError,
  ValidationError,
  MfaDisabled,
  InvalidFee,
  NotVerified,
  CoParentNotVerified,
  LinkUpdateRequired,
  NotEligibleForNextDayAch,
  InsufficientBalance,
  NotEligibleToMakePayments,
  ExceedsDailyLimit
}

export enum TosType {
  Dwolla = 3
}

export enum TransferStatus {
  Pending = 1,
  Processed,
  Failed,
  Canceled
}

export enum TransferType {
  Request = 1,
  Payment,
  NotSpecified
}

export enum RequestStatus {
  Requested = 1,
  Accepted,
  Declined,
  Canceled
}

export enum CustomerVerificationStatus {
  //initial state.
  PendingExternalVerification = 1,
  //happens after user adds a verified funding source.
  PendingInternalVerification,
  //happens after admin review process.
  Verified,
  //happens after admin review process.
  Failed
}

export enum ScheduledPaymentStatus {
  Enabled = 1,
  Disabled,
  Cancelled,
  SystemCanceledUnverifiedCustomer,
  SystemCanceledUnverifiedFundingSource,
  SystemCanceledCoParentUnverified,
  SystemCanceledCoParentFundingSourceUnverified,
  SystemCanceledFailedPayment = 9
}

export enum ActivityType {
  Request = 1,
  ScheduledPayment,
  SinglePayment,
  RequestScheduledPayment, // this is the request which is attached to a scheduled payment
  WalletPayment
}

export enum CustomerStatus {
  Unverified = 1,
  Verified,
  Retry,
  Document,
  Suspended,
  Deactivated
}

export enum DocumentStatus {
  Pending = 1,
  Reviewed
}

export enum FundingSourceStatus {
  Verified = 1,
  Unverified
}

export enum FundingSourceType {
  Checking = 1,
  Savings,
  Wallet
}

export enum FundingSourceMicroDepositStatus {
  Pending = 1,
  Processed,
  Failed,
  MaxAttempt
}

export enum FundingSourceDependencyAction {
  None,
  Cancel,
  Update
}

export enum FundingSourceMode {
  SelectSource = 1,
  Manage,
  SelectDestination
}

export enum FilterOption {
  Requests = 1,
  PendingPayments,
  SentPayments,
  ReceivedPayments,
  FailedPayments,
  DateRange,
  ScheduledPayments,
  UpcomingScheduledPayments
}

export enum ErrorType {
  ServerError,
  ValidationError,
  MfaDisabled,
  InvalidFee,
  NotApproved,
  NotEligibleToMakePayments,
  LinkUpdateRequired,
  NotEligibleForNextDayAch,
  InsufficientBalance
}

export enum CreateFundingSourceErrorType {
  ServerError,
  ValidationError,
  DuplicateAccountAll,
  DuplicateAccountSome
}

export enum MicroDepositErrorType {
  ServerError,
  ValidationError,
  MfaDisabled,
  FailedAttempt,
  MaxAttemptReached
}

export enum MoneyTransferClearingType {
  Standard = 1,
  NextDay
}
